import React from "react";
import TermsAndConditions from "../../../Shared/TermsAndConditions";
import LicenseTerms from "./_license_terms";
import PaymentModal from "./_payment_modal";
import {
  getLicenseFee,
  getValidHrefUrl,
  formatPrice,
} from "../../../utilities";

class LicenseAgreementAccepted extends React.Component {
  state = {
    videoLinkReceived: false,
    termsAccepted: false,
    paymentOpen: false,
  };

  onApprove = () => {
    const data = {
      purchased: true,
    };
    this.props.purchaseLicense(data);
  };

  render() {
    const {
      user: { first_name },
      agreement: {
        license_agreement: {
          purchased_at,
          download_link,
          total_price,
          influencer_royalties,
        },
      },
    } = this.props;
    const { videoLinkReceived, termsAccepted, paymentOpen } = this.state;
    const influencerRoyalties = influencer_royalties;
    const licenseFee = getLicenseFee(influencerRoyalties);
    const totalLicensePrice = Number(influencerRoyalties) + Number(licenseFee);
    const paymentPriceExplanation = `You will be charged ${formatPrice(
      influencerRoyalties
    )} +
      ${formatPrice(licenseFee)} (Vyrill fee) for a total of
      ${formatPrice(totalLicensePrice)}`;

    return (
      <div>
        <h4>
          <strong>Congrats!</strong>
        </h4>
        <p>
          {`${first_name} accepted your License Request, and has provided a
          link to the video for download `}
          <a
            className="download-link"
            href={getValidHrefUrl(download_link)}
            target="_blank"
          >
            here
          </a>
          . Please accept that you have received the video file in this folder.
        </p>
        <label className="auth-checkbox">
          <input
            type="checkbox"
            name="videoLinkReceived"
            onChange={(options) =>
              this.setState({ videoLinkReceived: options.target.checked })
            }
            checked={purchased_at || videoLinkReceived}
          />
          <span className="ms-1">
            By selecting the checkbox, you agree that you have received a copy
            of the video and have downloaded it for safe keeping.
          </span>
        </label>
        <div>
          <TermsAndConditions
            readOnly={purchased_at}
            termsAccepted={termsAccepted}
            onChange={(options) =>
              this.setState({ termsAccepted: options.target.checked })
            }
            termsLinkText="Terms of the License of Creator Content"
          >
            <LicenseTerms
              acceptTerms={() =>
                this.setState({ termsAccepted: !termsAccepted })
              }
              termsAccepted={termsAccepted}
            />
          </TermsAndConditions>
        </div>
        <div className="license-buttons">
          <button
            type="button"
            className="btn btn-primary mb-1"
            onClick={() => this.setState({ paymentOpen: true })}
            disabled={!videoLinkReceived || !termsAccepted}
          >
            <i className="icon-handshake" />
            {purchased_at ? "Purchased " : "Buy "} License
          </button>
          <span>{paymentPriceExplanation}</span>
        </div>
        {paymentOpen && (
          <PaymentModal
            close={() => this.setState({ paymentOpen: false })}
            onApprove={this.onApprove}
            totalLicensePrice={totalLicensePrice}
            paymentPriceExplanation={paymentPriceExplanation}
          />
        )}
      </div>
    );
  }
}

export default LicenseAgreementAccepted;
